import { xor } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAPI } from '../../../state';
var QUEUE_AVERAGE_API = '/api/multiskill/{planId}/average';
var QUEUE_API = '/api/queue/{id}';
var MULTI_SKILL_API = '/api/multiskill/{planId}';
var MULTISKILL_SIMULATION_API = '/api/report/simulation';
var useAverageAPI = function (queueIds) {
  var id = useParams().id;
  var _a = useAPI(QUEUE_AVERAGE_API, {
      planId: id
    }),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function () {
    fetchData(undefined, {
      queueIds: queueIds === null || queueIds === void 0 ? void 0 : queueIds.join(',')
    });
  }, [fetchData, queueIds]);
  return [data, fetchDataWrapper, clearData];
};
var useQueueAPI = function (id) {
  var _a = useAPI(QUEUE_API, {
      id: id
    }),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function () {
    if (id) {
      fetchData();
    }
  }, [fetchData, id]);
  return [data, fetchDataWrapper, clearData];
};
export var useGroupDetailAPI = function (data) {
  var queueAverage = useAverageAPI(data === null || data === void 0 ? void 0 : data.children);
  var queueDetail = useQueueAPI((data === null || data === void 0 ? void 0 : data.shrinkages) ? undefined : data === null || data === void 0 ? void 0 : data.id);
  var shouldUseAverage = useMemo(function () {
    return !!xor(data === null || data === void 0 ? void 0 : data._children, data === null || data === void 0 ? void 0 : data.children).length;
  }, [data === null || data === void 0 ? void 0 : data._children, data === null || data === void 0 ? void 0 : data.children]);
  return shouldUseAverage ? queueAverage : queueDetail;
};
export var useMultiSkillAPI = function () {
  var planId = useParams().id;
  return useAPI(MULTI_SKILL_API, {
    planId: planId
  }, 'POST');
};
export var useSimulationAPI = function () {
  var planId = useParams().id;
  var _a = useAPI(MULTISKILL_SIMULATION_API, {}, 'POST'),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchSimulation = useCallback(function () {
    fetchData(undefined, {
      plan_id: planId
    });
  }, [fetchData, planId]);
  return [data, fetchSimulation, clearData];
};